import { ACTION_TYPE_SENSOR_DATA } from '../actions/types';

const InitialState = {
    sensorData: {
        policy_no: '',
        date_time: '',
        reg_no: '',
        activity_type: '',
        activity_id: '',
        imageDetails: [
            {
                fileName: '',
                timestamp: 123456789,
                pose: '',
                attemptCount: 0,
                latitude: '',
                longitude: '',
                success: false,
                errorMsg: ''
            }
        ],
        sensor_data: [
            {
                millis: 123456789,
                compass: [
                    {
                        degree: 0,
                        timestamp: 123456789
                    }
                ],
                pedometer: [
                    {
                        step: 0,
                        timestamp: 123456789
                    }
                ],
                gyroscope: [
                    {
                        x: 0,
                        y: 0,
                        z: 0,
                        timestamp: 123456789
                    }
                ],
                accelerometers: [
                    {
                        x: 0,
                        y: 0,
                        z: 0,
                        timestamp: 123456789
                    }
                ],
                magnetometers: [
                    {
                        x: 0,
                        y: 0,
                        z: 0,
                        timestamp: 123456789
                    }
                ]
            },
        ],
    },
};

export default (state = InitialState, action) => {
    switch (action.type) {
        case ACTION_TYPE_SENSOR_DATA:
            return { ...state, sensorData: action.payload };
        default:
            return state;
    }
};
